export default {
    contactCoach(context, payload) {
        const newRequest = {
            id: new Date().toISOString(),
            coachId: payload.coachId,
            userEmail: payload.email,
            message:payload.message
        }
        // pošljemo v index.js addRequest iz mutations.js z transformiranimi vrednostmi iz newRequest
        context.commit('addRequest', newRequest)
    }
};
